import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiEndPoint} from '../../utility/api-end-point';
import {DropdownDto} from '../../dto/common/dropDown/dropdown-dto';
import {TableColumnsDto} from '../../dto/table/table-columns-dto';
import {TableSearchFilterDataDto} from '../../dto/table/table-search-filter-data-dto';
import {UserMasterDto} from '../../dto/user/user-master-dto';
import {map} from "rxjs/operators";
import {TenantDto} from '../../dto/tenant/tenant-dto';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  constructor(public httpClient: HttpClient) {
  }


  getTenantList() {
    return this.httpClient.get(ApiEndPoint.API_URL + '/tenant_management/get_sub_account_and_portal_dropdown', {
      observe: 'response'
    });
  }


  filterAccordingToSelectedValue(filterValue) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/common_service/sec_export_tenant_transaction_report', filterValue, {
      responseType: 'blob', observe: 'response'
    })
      .pipe(map(res => {
        return {
          filename: 'filename.csv',
          result: res,
          data: new Blob([res.body], {type: 'text/plain'})
        };
      }));
    ;
  }

  /**
   * get available sftp server
   * @param serverStatus to serverStatus
   */
  getAvailableSftpServers(serverStatus: any) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/tenant_management/sec_get_supported_sftp_servers_v2', {},
      {params: {status: serverStatus}, observe: 'response', withCredentials: true});
  }

  /**
   * get available db server
   * @param dbClass to selected id
   * @param serverStatus to status
   */
  getAvailableDBServers(dbClass: string, serverStatus: any) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/tenant_management/sec_get_supported_db_servers_v2', {},
      {params: {serverName: dbClass, status: serverStatus}, observe: 'response', withCredentials: true});
  }

  getTenantTableData(filter) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/tenant_management/sec_search_tenant', filter,
      {withCredentials: true, observe: 'response'});
  }

  /**
   * this method can be used to get package name list
   */
  getPackageNameList() {
    return this.httpClient.get(ApiEndPoint.API_URL + '/tenant_management/sec_get_package_name_list',
      {withCredentials: true});
  }


  createTenant(value) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/tenant_management/sec_create_tenant', value,
      {observe: 'response', withCredentials: true});
  }

  deleteTenant(id) {
    return this.httpClient.delete(ApiEndPoint.API_URL + '/tenant_management/sec_delete_tenant', {
      observe: 'response', params: {id}
    });
  }

  migrateAuth0Tenant(tenantId) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/tenant_management/config_auth0', {}, {
      observe: 'response', params: {tenantId}
    });
  }

  getSubClientList() {
    return this.httpClient.get(ApiEndPoint.API_URL + '/tenant_management/sec_get_sub_account_list_with_tenant_id',
      {observe: 'response'});
  }

  /**
   * this method can be used to get Tenant package Details
   */
  getPackagesDetails() {
    return this.httpClient.get<DropdownDto[]>(ApiEndPoint.API_URL + '/tenant_management/sec_get_papertrl_packages',
      {observe: 'response'});
  }

  /**
   * This service use for update tenant
   * @param tenantData TenantDto
   */
  updateTenant(id, packageId) {
    return this.httpClient.put(ApiEndPoint.API_URL + '/tenant_management/update_tenant_package_id', '',
      {observe: 'response', params: {id, packageId}});
  }

  getTenantData(id) {
    return this.httpClient.get(ApiEndPoint.API_URL + '/tenant_management/sec_get_papertrl_package_related_to_package',
      {observe: 'response', params: {id}});
  }
}
